import getLogosBySite from './getLogosBySite';
import getPhoneNumber from './getPhoneNumber';
import defaultPhone from './defaultPhone';
import printLogos from './printLogos';
import printPhoneNumber from './printPhoneNumber';
import defaultPhoneV3 from '../../core/getInvocaPhoneV3/defaultPhoneV3';
import getPhoneNumberV3 from './getPhoneNumberV3';
import defaultPhoneV5 from '../../core/getPhoneCallManagement/defaultPhone';
import getPhoneNumberV5 from './getPhoneNumberV5';

export default {
  getLogosBySite,
  getPhoneNumber,
  objPhone: defaultPhone,
  printLogos,
  printPhoneNumber,
  getPhoneNumberV3,
  objPhoneV3: defaultPhoneV3,
  getPhoneNumberV5,
  objPhoneV5: defaultPhoneV5,
};
